import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
} from "@mui/material";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import { marked } from "marked";

const ViewQuestions = ({ text, isDialogOpen, onClose }) => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    let html = "";

    if (Array.isArray(text)) {
      html = text
        .map((q) => {
          const rawAnswer = q.answer || "_No answer yet_";
          let parsedAnswer = marked.parse(rawAnswer);

          parsedAnswer = parsedAnswer.replace(
            /(^|\n|\r)(\d+)\.(\s+)/g,
            '$1<strong>$2.</strong>$3'
          );

          return `
            <div class="qa-block">
              <p class="question">
                <i class="fa-solid fa-arrow-right-to-bracket" style="margin-right: 8px;"></i>
                <strong>${q.question}</strong>
              </p>
              <div class="answer">

                <div class="answer-body">${parsedAnswer}</div>
              </div>
              <div class="separator"></div>
            </div>
          `;
        })
        .join("");
    } else {
      html = `<p>${text || "No questions available."}</p>`;
    }

    setHtmlContent(DOMPurify.sanitize(html));
  }, [text]);

  return (
    <Dialog
      open={isDialogOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
         
          position: "absolute",
        
       
          
        },
      }}
    >
      <DialogTitle>Emailed Questions & Answers</DialogTitle>
      <DialogContent dividers sx={{ padding: "40px" }}>
        <div
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          style={{
            lineHeight: "1.6",
            fontSize: "1rem",
            textAlign: "left",
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: "teal",
            color: "#fff",
            textTransform: "none",
            fontWeight: 600,
            px: 1.5,
            py: 1,
            "&:hover": {
              background: "teal",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>

      <style>
        {`
          .answer {
            background-color: #f9fafb;
            padding: 12px;
            border-radius: 6px;
            margin: 10px 0;
          }

          .answer-body p,
          .answer-body ul,
          .answer-body ol {
            margin: 0;
            padding-left: 1.2em;
          }

          .answer-body li {
            margin-bottom: 0.3em;
          }

          .separator {
            height: 2px;
            background-color: #000;
            margin: 20px 0;
            width: 100%;
          }

          .question {
            font-weight: bold;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .answer-body strong {
            font-weight: 600;
          }
        `}
      </style>
    </Dialog>
  );
};

ViewQuestions.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isDialogOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ViewQuestions;
